<template>
  <v-card flat class="general-card">
    <slot></slot>
  </v-card>
</template>

<script>
// @ is an alias to /src
export default {
  name: "GeneralCard",
  data: () => ({}),
  props: {},
  mounted() {},
  methods: {},
  watch: {},
};
</script>

<style scoped>
.general-card {
  background-color: #eff6ff;
  border-radius: 10px;
  padding: 16px;
  color: #000000;
  border-color: #bedbff;
  border-width: 2px;
  border-style: solid;
}

.theme--dark .general-card {
  background-color: #1e1e2e;
  color: #e0e0e0;
  border-color: #444;
}
</style>
